var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 751.26,
    height: 576.845,
    viewBox: "0 0 751.26 576.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{opacity:0.5;}.b{fill:url(#a);}.c,.i{fill:#ed1d24;}.d{fill:#707070;}.e{fill:#5e5e5e;}.f{fill:#cbccce;}.g{fill:url(#b);}.h{fill:url(#c);}.j{fill:#fff;}.k{fill:url(#e);}.l{fill:url(#f);}.m{fill:url(#g);}.n{fill:url(#h);}.o{fill:#9dc44d;}.p{fill:url(#i);}.q{fill:url(#k);}.r{fill:#e5e5e6;}.s{fill:#ff5b00;}.t{fill:#d54c00;}.u{fill:#d6ac63;}.v{fill:gray;}.w{fill:url(#m);}.x{fill:url(#n);}.y{fill:url(#o);}.z{fill:url(#p);}.aa{fill:url(#q);}.ab{fill:url(#r);}.ac{fill:url(#s);}.ad{fill:url(#t);}.ae{fill:url(#u);}.af{fill:url(#w);}.ag{fill:url(#y);}.ah{fill:url(#ab);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a10308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a10308"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 0.865,
    x2: 0.5,
    y2: 0.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#394967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232d4a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 12.8,
    x2: 0.5,
    y2: 2.181,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6d4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.5,
    y1: 0.151,
    x2: 0.5,
    y2: 0.95,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.5,
    y1: 1.966,
    x2: 0.5,
    y2: 0.272,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ededed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc5d17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e79a49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.5,
    y1: -0.125,
    x2: 0.5,
    y2: 0.814,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0cd30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8ab28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.5,
    y1: 0.19,
    x2: 0.5,
    y2: 1.586,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.5,
    y1: 1.478,
    x2: 0.5,
    y2: 0.199,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ededed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a10308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed1d24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5dec3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c77c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0.5,
    y1: 1.19,
    x2: 0.5,
    y2: 0.348,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0.5,
    y1: 0.996,
    x2: 0.5,
    y2: -0.135,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 0.5,
    y1: 1.019,
    x2: 0.5,
    y2: -0.158,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0.5,
    y1: 1.043,
    x2: 0.5,
    y2: -0.166,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 0.5,
    y1: 7.945,
    x2: 0.5,
    y2: 6.44,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e5e5e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 0.809,
    y1: 1.029,
    x2: 0.482,
    y2: 0.338,
    xlinkHref: "#b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-263.457 -130.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(653.756 130.93)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M497.9,238.419a72.847,72.847,0,0,0,3.85,12.054l-.446.579-12.839,16.682a93.031,93.031,0,0,0,12.165,16.754l19.914-7.086.7-.247a73.354,73.354,0,0,0,10.189,7.39l-.02.752-.586,21.131a92.147,92.147,0,0,0,19.677,6.417l11.933-17.421.433-.632c2.086.179,4.18.319,6.31.319s4.226-.14,6.31-.319l.433.632,11.933,17.421a92.141,92.141,0,0,0,19.677-6.417l-.586-21.131-.02-.752a73.512,73.512,0,0,0,10.191-7.39l.7.247,19.914,7.086A93.149,93.149,0,0,0,649.9,267.734l-12.841-16.682-.446-.579a72.641,72.641,0,0,0,3.85-12.054l.73-.216,20.237-5.962a91.071,91.071,0,0,0,0-20.705L641.2,205.573l-.73-.216a72.642,72.642,0,0,0-3.85-12.054l.446-.579L649.9,176.042a93.147,93.147,0,0,0-12.167-16.754l-19.914,7.086-.7.249a73.346,73.346,0,0,0-10.191-7.392l.02-.752.586-21.129a92.146,92.146,0,0,0-19.677-6.419l-11.933,17.421-.433.632c-2.083-.179-4.18-.319-6.31-.319s-4.226.14-6.31.319l-.433-.632L550.508,130.93a92.152,92.152,0,0,0-19.677,6.419l.586,21.129.02.752a73.34,73.34,0,0,0-10.191,7.392l-.7-.249-19.914-7.086a93.029,93.029,0,0,0-12.165,16.754l12.839,16.682.446.579a72.848,72.848,0,0,0-3.85,12.054l-.73.216-20.237,5.962a91.089,91.089,0,0,0,0,20.705l20.237,5.962Zm33.362-16.531a37.919,37.919,0,1,1,37.918,37.921A37.919,37.919,0,0,1,531.266,221.888Z",
    transform: "translate(-476.346 -130.93)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M546.2,347.876l-25.791,14.592a135.431,135.431,0,0,0,6.848,21.188l29.494-3.36a108.577,108.577,0,0,0,5.534,9.57L544.648,413.7a137.187,137.187,0,0,0,14.924,16.547l25.53-15.038a109.019,109.019,0,0,0,8.94,6.5l-6.424,28.978a135.269,135.269,0,0,0,20.347,9.047l17.216-24.136a107.349,107.349,0,0,0,10.827,2.3l5.905,29.016c3.677.3,7.388.492,11.142.492s7.464-.192,11.144-.492l5.9-29.016a107.4,107.4,0,0,0,10.829-2.3l17.216,24.136a135.373,135.373,0,0,0,20.347-9.047L712.07,421.7a109.019,109.019,0,0,0,8.94-6.5l25.53,15.038A137.191,137.191,0,0,0,761.463,413.7l-17.635-23.834a108.032,108.032,0,0,0,5.534-9.57l29.494,3.36a135.162,135.162,0,0,0,6.848-21.188l-25.791-14.592a108.514,108.514,0,0,0,1.148-11.008l28.237-8.905A136.7,136.7,0,0,0,787,305.8l-29.494-2.84a107.923,107.923,0,0,0-3.424-10.525L776.3,272.778a136.12,136.12,0,0,0-11.164-19.271l-28.115,9.406a108.445,108.445,0,0,0-7.392-8.225l12.283-26.949a136.875,136.875,0,0,0-17.992-13.134l-21.879,20.047a108.107,108.107,0,0,0-10.1-4.506l.258-29.658a135.543,135.543,0,0,0-21.8-4.594l-11.811,27.161q-2.748-.138-5.534-.14t-5.534.14l-11.811-27.161a135.518,135.518,0,0,0-21.794,4.594l.258,29.658a108.144,108.144,0,0,0-10.1,4.506l-21.879-20.047a136.845,136.845,0,0,0-17.99,13.134l12.281,26.949a108.969,108.969,0,0,0-7.392,8.225l-28.115-9.406a136.106,136.106,0,0,0-11.161,19.271l22.216,19.656a107.331,107.331,0,0,0-3.424,10.525l-29.5,2.84a136.931,136.931,0,0,0-2.3,22.163l28.239,8.905A107.854,107.854,0,0,0,546.2,347.876Zm51.9-16.8a54.955,54.955,0,1,1,54.955,54.955A54.955,54.955,0,0,1,598.1,331.078Z",
    transform: "translate(-428.337 -53.858)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(436.268 299.029)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 466.908,
    height: 265.36,
    rx: 3.222
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M560.667,329.184h-91.51l-11.859,45.4H572.526Z",
    transform: "translate(-281.458 -63.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M652.254,373.363H434.991a1.891,1.891,0,0,1-1.111-3.422l9.854-7.147a67.44,67.44,0,0,1,39.6-12.845H603.918a67.45,67.45,0,0,1,39.6,12.845l9.852,7.147A1.891,1.891,0,0,1,652.254,373.363Z",
    transform: "translate(-310.169 -39.188)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 239.501,
    height: 441.737,
    transform: "translate(454.322 10.561) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M441.586,238.751H404.1a7.186,7.186,0,0,1-7.185-7.187h0a7.184,7.184,0,0,1,7.185-7.184h37.483a7.184,7.184,0,0,1,7.185,7.184h0A7.186,7.186,0,0,1,441.586,238.751Z",
    transform: "translate(-353.091 -188.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M434.07,238.751H723.323a7.186,7.186,0,0,0,7.184-7.187h0a7.184,7.184,0,0,0-7.184-7.184H434.07a7.184,7.184,0,0,0-7.184,7.184h0A7.186,7.186,0,0,0,434.07,238.751Z",
    transform: "translate(-317.537 -188.161)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 369.527,
    height: 11.29,
    transform: "translate(43.826 76.146)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 369.527,
    height: 11.29,
    transform: "translate(43.826 97.298)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 109.358,
    height: 92.246,
    transform: "translate(43.826 123.521)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 243.856,
    height: 92.246,
    transform: "translate(169.497 123.521)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.457 168.461)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 148.716,
    height: 106.325,
    rx: 2.61,
    transform: "translate(0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M565.009,304.243V291.473a5.706,5.706,0,0,0-5.707-5.706H422a5.708,5.708,0,0,0-5.709,5.706v12.771Z",
    transform: "translate(-416.293 -285.766)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M427.467,292.223a4.114,4.114,0,1,1-4.113-4.113A4.114,4.114,0,0,1,427.467,292.223Z",
    transform: "translate(-412.797 -282.985)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M434.825,292.223a4.114,4.114,0,1,1-4.113-4.113A4.114,4.114,0,0,1,434.825,292.223Z",
    transform: "translate(-404.067 -282.985)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M442.183,292.223a4.114,4.114,0,1,1-4.113-4.113A4.114,4.114,0,0,1,442.183,292.223Z",
    transform: "translate(-395.338 -282.985)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.817 35.728)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M492.719,325.325,472,304.607a2.09,2.09,0,0,0-2.956,2.956l19.24,19.238-19.24,19.24A2.089,2.089,0,1,0,472,348.995l20.716-20.716A2.085,2.085,0,0,0,492.719,325.325Z",
    transform: "translate(-364.25 -299.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M445.067,304.607a2.089,2.089,0,0,0-2.954,0l-20.718,20.718a2.089,2.089,0,0,0,0,2.954l20.718,20.716a2.089,2.089,0,0,0,2.954-2.954L425.829,326.8l19.238-19.238A2.088,2.088,0,0,0,445.067,304.607Z",
    transform: "translate(-420.783 -299.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M462.1,302.291a2.091,2.091,0,0,0-2.764,1.052L436.12,355.12a2.09,2.09,0,1,0,3.813,1.712l23.219-51.78A2.092,2.092,0,0,0,462.1,302.291Z",
    transform: "translate(-402.806 -302.107)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M448.311,317.612c-4.491,0-4.491,6.966,0,6.966S452.8,317.612,448.311,317.612Z",
    transform: "translate(-392.121 -283.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M454.683,317.612c-4.491,0-4.491,6.966,0,6.966S459.176,317.612,454.683,317.612Z",
    transform: "translate(-384.561 -283.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M461.055,317.612c-4.491,0-4.491,6.966,0,6.966S465.548,317.612,461.055,317.612Z",
    transform: "translate(-377.002 -283.712)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.939 504.057)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M548.724,450.75H532.7L502.607,299.3h16.022Z",
    transform: "translate(-493.374 -299.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M596.561,450.75h16.022L582.488,299.3H566.466Z",
    transform: "translate(-417.612 -299.302)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 16.022,
    height: 151.447,
    transform: "translate(9.233)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 16.022,
    height: 151.447,
    transform: "translate(164.876 151.447) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 174.109,
    height: 37.296
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M520.607,299.3l-22.223,20.641V336.6h5.268l40.155-37.3Z",
    transform: "translate(-498.384 -299.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M553.388,299.3l-40.155,37.3h23.2l40.155-37.3Z",
    transform: "translate(-480.767 -299.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M576.438,299.3l-40.155,37.3h23.2l40.155-37.3Z",
    transform: "translate(-453.421 -299.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M600.183,299.3h-.695l-40.155,37.3h23.2l17.65-16.393Z",
    transform: "translate(-426.074 -299.302)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 174.109,
    height: 37.296,
    transform: "translate(0 62.413)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 62.413)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M520.607,327.849l-22.223,20.641v16.655h5.268l40.155-37.3Z",
    transform: "translate(-498.384 -327.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M553.388,327.849l-40.155,37.3h23.2l40.155-37.3Z",
    transform: "translate(-480.767 -327.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M576.438,327.849l-40.155,37.3h23.2l40.155-37.3Z",
    transform: "translate(-453.421 -327.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M600.183,327.849h-.695l-40.155,37.3h23.2l17.65-16.393Z",
    transform: "translate(-426.074 -327.849)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(798.211 603.546)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M635.478,337.488h0a14.4,14.4,0,0,0-13.3,8.888L586.66,432.121H684.3L648.78,346.376A14.4,14.4,0,0,0,635.478,337.488Z",
    transform: "translate(-567.927 -337.488)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 135.102,
    height: 9.596,
    rx: 2.194,
    transform: "translate(0 94.633)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.748 13.339)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M636.523,343.589H606.232l-7.686,18.556h45.663Z",
    transform: "translate(-582.574 -343.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M591.24,379.781h77.607l-7.686-18.556H598.927Z",
    transform: "translate(-591.24 -322.665)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(522.934 188.668)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M518.585,177.018c-2.1,1.71-4.587,1.469-7.311,0v-8.267h7.311Z",
    transform: "translate(-484.087 -143.797)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.975 88.938)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M574.412,217.245c1.229-4.46-1.209-9.135-5.359-10.267l-31.239-8.529-23.893-.433,2.543,8.061c0,7.862,5.853,14.233,13.072,14.233H560.2l3.529,27.072,10.508-2.16Z",
    transform: "translate(-513.921 -198.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M557.72,230.709a5.684,5.684,0,0,0-7.683-5.077l-2.871,1.043.044-7.069-10.508,2.16,1.331,10.219a4.447,4.447,0,0,0,4.137,5.245l13.682-4.388a1.956,1.956,0,0,0,1.869-2.033Z",
    transform: "translate(-486.894 -172.401)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M516.505,183.2a12.207,12.207,0,0,1-5.024-2.541c-1.9-1.861-2.436-4.681-2.764-7.32q-.482-3.886-.651-7.805a4.672,4.672,0,0,1,.435-2.68,4.361,4.361,0,0,1,3.081-1.611,23.578,23.578,0,0,1,14.174,1.865,48.3,48.3,0,0,0,.455,12.594c.354,2.095.807,4.416-.33,6.212a5.382,5.382,0,0,1-4.379,2.226A14.814,14.814,0,0,1,516.505,183.2Z",
    transform: "translate(-487.912 -153.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M507.316,162.267a59.63,59.63,0,0,0,.606,13.3,9.761,9.761,0,0,0,.684,2.593,3.667,3.667,0,0,0,1.821,1.893,3.478,3.478,0,0,0,3.573-.789,6.343,6.343,0,0,0,1.751-3.376c.208-.947-.842-1.574-1.609-2.16a6.616,6.616,0,0,1-2.055-2.011,2.612,2.612,0,0,1,.039-2.492,2.221,2.221,0,0,1,2.208-1.06,1.939,1.939,0,0,1,1.59,1.8c.4-.317.931-.617,1.334-.936a5.037,5.037,0,0,1-1.972-3.3,4.882,4.882,0,0,1,.9-3.675A12.86,12.86,0,0,0,507.316,162.267Z",
    transform: "translate(-488.938 -152.564)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.055 33.22)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M534.842,173.236l-8.046-.7h-7.311l-11.7,1.194L504.353,229.5l35.592-1.251-3.7-54.73A6.936,6.936,0,0,0,534.842,173.236Z",
    transform: "translate(-504.353 -172.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M529.009,220.7l-5.16-41.9a6.963,6.963,0,0,0-4.908-5.809l3.7,54.73,4.209-.149Z",
    transform: "translate(-487.046 -171.996)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M514.327,173.078l-1.99.328a5.661,5.661,0,0,0-4.513,3.988l-8.715,29.612a6.656,6.656,0,0,0,3.275,7.762l21.892,11.573,3.148-4.2-18.121-14.782,3.653-12.016Z",
    transform: "translate(-498.839 -138.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M513.622,195.589a12.685,12.685,0,0,1,5.468.413l-.636,3.116a6.36,6.36,0,0,1-5.149.667,2.351,2.351,0,0,1-2.831,0Z",
    transform: "translate(-485.036 -112.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M511.983,211.036h31.649l10.163-23.63h-31.65Z",
    transform: "translate(-483.245 -121.665)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.055 89.371)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M567.448,217.01a8.166,8.166,0,0,0-5.833-10.267L527.6,198.214l-23.248.818v6.811a14.233,14.233,0,0,0,14.233,14.233h33.388l-4.237,27.785h10.455Z",
    transform: "translate(-504.353 -198.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M539.484,227.662h-6.041l2.022-6.741H525.01l-1.447,9.506a4.557,4.557,0,0,0,4.506,5.245h15.357a2.034,2.034,0,0,0,2.033-2.036A5.974,5.974,0,0,0,539.484,227.662Z",
    transform: "translate(-481.626 -171.275)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M531.346,164.536l-4.06.444a10.276,10.276,0,0,0-20.2,3.131c.009.328.039.649.077.969,6.8-.273,13.706-.824,20.5-1.762l3.914-.319a1.237,1.237,0,1,0-.234-2.462Z",
    transform: "translate(-489.057 -157.338)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.808 485.17)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M367.557,344.046l-23.095-.538c10.436,29.884,17.607,57.13,17.679,78.646h10.453C375.216,401.347,372.352,373.87,367.557,344.046Z",
    transform: "translate(-305.864 -232.971)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.734,386.22H362.7l.306-6.741H352.548l.969,9.506a6.2,6.2,0,0,0,5.84,5.245h13.357a1.53,1.53,0,0,0,1.517-2.036C373.391,388.9,372.895,386.22,368.734,386.22Z",
    transform: "translate(-296.271 -190.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M364.527,344.99l-22.957-.538c2.836,29.883,3.072,57.13-2.328,78.649h10.453C357.609,402.291,361.735,374.814,364.527,344.99Z",
    transform: "translate(-312.058 -231.851)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.528,387.163h-6.039l2.02-6.738H340.056l-1.45,9.5a4.558,4.558,0,0,0,4.506,5.245H358.47a2.036,2.036,0,0,0,2.036-2.036A5.977,5.977,0,0,0,354.528,387.163Z",
    transform: "translate(-312.873 -189.174)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M353.387,354.928,363.72,353.2l7.313-1h7.051l8.391-23.716-12.263-27.085,5.271-3.179L395.571,326.6a7.583,7.583,0,0,1,.678,5.886L386.222,366.5l1.653,31.283s-16.658,5.468-32.044,1.526l-2.444-28.231L332.5,351.158a11.882,11.882,0,0,1-3.658-7.88L327.22,316.27l6.1.509,4.959,25.432Z",
    transform: "translate(-326.32 -286.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M349.83,307.639l-1.5-2.831a4.738,4.738,0,0,1,.724-5.457l5.989-6.4,1.2,2.954a5.13,5.13,0,0,1-1.124,5.556l-1.03,1.028,1.019,1.972Z",
    transform: "translate(-301.937 -292.951)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M333.813,313.709V313.2a4.789,4.789,0,0,1,1.423-3.409l1.373-1.36-4.768-7.628-2.8,2.372a6.315,6.315,0,0,0-2.116,6.032l.783,3.992Z",
    transform: "translate(-326.808 -283.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M351.228,327.849c-2.106,1.71-4.589,1.469-7.313,0V319.58h7.313Z",
    transform: "translate(-306.514 -261.359)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M354.589,334.25a12.225,12.225,0,0,1-5.619-.356c-2.482-.96-4.082-3.343-5.424-5.641q-1.974-3.381-3.673-6.916a4.656,4.656,0,0,1-.656-2.635,4.364,4.364,0,0,1,2.2-2.7,23.561,23.561,0,0,1,13.763-3.87,48.231,48.231,0,0,0,5.381,11.4c1.15,1.786,2.479,3.741,2.143,5.84a5.37,5.37,0,0,1-3.148,3.769A14.837,14.837,0,0,1,354.589,334.25Z",
    transform: "translate(-312.121 -270.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M338.27,317.531a59.471,59.471,0,0,0,5.8,11.984,9.769,9.769,0,0,0,1.648,2.114,3.667,3.667,0,0,0,2.42,1.023,3.482,3.482,0,0,0,2.973-2.134,6.339,6.339,0,0,0,.28-3.793c-.184-.949-1.395-1.113-2.331-1.351a6.6,6.6,0,0,1-2.681-1.039,2.614,2.614,0,0,1-.949-2.307,2.222,2.222,0,0,1,1.614-1.843,1.934,1.934,0,0,1,2.169,1.025c.245-.45.612-.936.859-1.386a5.034,5.034,0,0,1-3.113-2.254,4.887,4.887,0,0,1-.621-3.734A12.85,12.85,0,0,0,338.27,317.531Z",
    transform: "translate(-313.21 -268.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M359.739,311.212l-3.555,2.007a10.276,10.276,0,0,0-17.329,10.836c.138.3.291.582.453.859,6.146-2.93,12.272-6.157,18.147-9.7l3.47-1.834a1.237,1.237,0,1,0-1.185-2.171Z",
    transform: "translate(-313.692 -273.578)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350.959 391.499) rotate(17)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M390.752,285.835l-59.465,59.223a16.03,16.03,0,0,0,1.008,23.189c6.494,5.685,16.422,4.93,22.406-1.288l56.857-56.512a29.589,29.589,0,0,0,37.234-20.93,1.849,1.849,0,0,0-2.659-2.075l-19.109,10.046L410.6,287.121l.767-19.406,19.109-10.046a1.847,1.847,0,0,0-.2-3.365,29.6,29.6,0,0,0-39.526,31.532ZM337.4,350.541a7.76,7.76,0,1,1,.212,10.973A7.763,7.763,0,0,1,337.4,350.541Z",
    transform: "translate(-326.809 -252.499)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.227dea4d91154f43c1dbdf7794528528.svg";
export { ForwardRef as ReactComponent };